import { Grid, html } from 'gridjs';
import '../../../node_modules/gridjs/dist/theme/mermaid.css';

new Grid({
  className: {
    table: 'text-xs',
    header: '',
    th: 'font-bold uppercase text-center',
    td: 'text-center',
  },
  sort: true,
  fixedHeader: true,
  search: {
    enabled: true,
  },
  pagination: {
    enabled: true,
    summary: true,
    limit: 10,
  },
  language: {
    search: {
      placeholder: '🔍 Buscador',
    },
    pagination: {
      previous: '👈',
      next: '👉',
      showing: 'Mostrando',
      results: () => 'Total',
    },
  },
  columns: [
    {
      id: 'id',
      name: 'Sucursal',
      hidden: true,
    },
    {
      id: 'address',
      name: 'Dirección',
      formatter: (_, row) =>
        html(
          `<a href='https://www.google.com.ar/maps/search/carrefour+express/@${row.cells[2].data},${row.cells[3].data},18z' target='_blank'><i class='fas fa-map-marker-alt'></i> ${row.cells[1].data}</a>`
        ),
    },
    {
      id: 'latitud',
      hidden: true,
    },
    {
      id: 'longitud',
      hidden: true,
    },
    {
      id: 'city',
      name: 'Barrio',
    },
    {
      id: 'state',
      name: 'Provincia',
    },
    {
      id: 'pagofacil',
      name: 'Pago Facil',
    },
  ],
  data: [
    {
      id: 196,
      address: 'Av. Corrientes 3651',
      latitud: -34.6035616,
      longitud: -58.4183597,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 199,
      address: 'Av. Córdoba 1439',
      latitud: -34.5991998,
      longitud: -58.3896682,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 200,
      address: 'Av. Rivadavia 8421',
      latitud: -34.6337284,
      longitud: -58.4842054,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 213,
      address: 'Paraguay 919',
      latitud: -34.5976748,
      longitud: -58.3823198,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 242,
      address: 'Av. Nazca 25',
      latitud: -34.6301916,
      longitud: -58.4718976,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 247,
      address: 'Av. La Plata 430',
      latitud: -34.6197278,
      longitud: -58.4302967,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 250,
      address: 'Carlos Pellegrini 587',
      latitud: -34.6015337,
      longitud: -58.3831455,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 A 20',
    },
    {
      id: 251,
      address: 'Arce 728',
      latitud: -34.5686712,
      longitud: -58.4370565,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 260,
      address: 'Av. Gral. Las Heras 2397',
      latitud: -34.5886097,
      longitud: -58.3979476,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 265,
      address: 'Av. Ángel Gallardo 30',
      latitud: -34.6024291,
      longitud: -58.4347988,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 291,
      address: 'Piedras 383',
      latitud: -34.6125496,
      longitud: -58.3799452,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 298,
      address: 'Formosa 565',
      latitud: -34.6213342,
      longitud: -58.4384353,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 299,
      address: 'Arenales 975',
      latitud: -34.5940826,
      longitud: -58.3833846,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 300,
      address: 'Gral. Deheza 2239',
      latitud: -34.5405341,
      longitud: -58.4742412,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 301,
      address: 'Av. Pueyrredón 2464',
      latitud: -34.5902219,
      longitud: -58.4023519,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 302,
      address: 'Esmeralda 823',
      latitud: -34.5986136,
      longitud: -58.380397,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 15',
    },
    {
      id: 303,
      address: 'Talcahuano 841',
      latitud: -34.5987698,
      longitud: -58.3875473,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 304,
      address: 'Suipacha 726',
      latitud: -34.6011727,
      longitud: -58.3808914,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '9 a 11',
    },
    {
      id: 306,
      address: 'Fray Justo Sta. María de Oro 2709',
      latitud: -34.5771937,
      longitud: -58.424543,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 307,
      address: 'Av. Gral. Las Heras 1936',
      latitud: -34.5907315,
      longitud: -58.3955703,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 308,
      address: 'Maipú 171',
      latitud: -34.6061507,
      longitud: -58.3786409,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 A 20',
    },
    {
      id: 309,
      address: 'Campana 3050',
      latitud: -34.6025502,
      longitud: -58.4987127,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 310,
      address: 'Chivilicoy 3840',
      latitud: -34.6005134,
      longitud: -58.5136168,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 311,
      address: 'Monroe 2771',
      latitud: -34.5601636,
      longitud: -58.4653697,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 312,
      address: 'Cerviño 4634',
      latitud: -34.5754428,
      longitud: -58.4251179,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 313,
      address: 'Montañeses 2267',
      latitud: -34.5559608,
      longitud: -58.4522338,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 314,
      address: 'Av. Segurola 2344 2344',
      latitud: -34.6147217,
      longitud: -58.5079317,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 315,
      address: 'José Pedro Varela 3191',
      latitud: -34.6009051,
      longitud: -58.5046272,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 316,
      address: 'Ramón Falcón 2402',
      latitud: -34.6346074,
      longitud: -58.4923619,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 317,
      address: 'Anchorena 1253',
      latitud: -34.5947527,
      longitud: -58.408576,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 318,
      address: 'Arroyo 859',
      latitud: -34.5915497,
      longitud: -58.3814946,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 320,
      address: 'Sucre 2480',
      latitud: -34.5644189,
      longitud: -58.4579452,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 321,
      address: 'Cangallo 33',
      latitud: -34.6060884,
      longitud: -58.4334907,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 322,
      address: 'Del Carril 3210',
      latitud: -34.5933399,
      longitud: -58.5044458,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 323,
      address: 'Montes de Oca 304',
      latitud: -34.6322153,
      longitud: -58.3781864,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 324,
      address: 'Directorio 1766',
      latitud: -34.6310634,
      longitud: -58.4547572,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 325,
      address: 'Vidal 2357',
      latitud: -34.5617506,
      longitud: -58.4645267,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 326,
      address: 'Av. Álvarez Jonte 4872',
      latitud: -34.6202673,
      longitud: -58.5087652,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 327,
      address: 'Av. Gral. Las Heras 2643',
      latitud: -34.5848163,
      longitud: -58.402228,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 328,
      address: 'Godoy Cruz 2793',
      latitud: -34.5777925,
      longitud: -58.4265189,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 329,
      address: 'Lavalle 1749',
      latitud: -34.6030081,
      longitud: -58.3939789,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 330,
      address: 'Fitz Roy 2470',
      latitud: -34.5777804,
      longitud: -58.4313554,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 331,
      address: 'Charcas 3171',
      latitud: -34.5924253,
      longitud: -58.4130376,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 332,
      address: 'Billinghurst 1380',
      latitud: -34.5939769,
      longitud: -58.4150093,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 334,
      address: 'Paraguay 521',
      latitud: -34.5973164,
      longitud: -58.3767951,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9 / 17 a 19',
    },
    {
      id: 335,
      address: 'Cuba 2776',
      latitud: -34.5546811,
      longitud: -58.4624422,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 336,
      address: 'Charcas 3315',
      latitud: -34.5913073,
      longitud: -58.4147303,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 337,
      address: 'Av. Federico Lacroze 2566',
      latitud: -34.5722106,
      longitud: -58.448255,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 338,
      address: 'Tucumán 831',
      latitud: -34.6011727,
      longitud: -58.3808908,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 339,
      address: 'Av. de Los Incas 4466',
      latitud: -34.5839161,
      longitud: -58.4797731,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 340,
      address: 'Ortega y Gasset 1876',
      latitud: -34.5707045,
      longitud: -58.4350486,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 341,
      address: 'Viamonte 351',
      latitud: -34.599551,
      longitud: -58.3742283,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 A 20',
    },
    {
      id: 343,
      address: 'Amenábar 1187',
      latitud: -34.569913,
      longitud: -58.4526574,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 344,
      address: 'Marcelo T. de Alvear 2251',
      latitud: -34.5968485,
      longitud: -58.4017432,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 345,
      address: 'Av. Pueyrredón 672',
      latitud: -34.6022548,
      longitud: -58.4072426,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 346,
      address: 'Suárez 1599',
      latitud: -34.6383878,
      longitud: -58.3754854,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 347,
      address: 'Josá Andrés Pacheco de Melo 2648',
      latitud: -34.5869042,
      longitud: -58.4036623,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 348,
      address: 'Av. Rivadavia 3421',
      latitud: -34.6104393,
      longitud: -58.4143787,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 349,
      address: 'Av. Cabildo 34',
      latitud: -34.5748311,
      longitud: -58.4383426,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 350,
      address: 'Humboldt 1982',
      latitud: -34.5825869,
      longitud: -58.4351824,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 351,
      address: 'Echeverría 2067',
      latitud: -34.5609588,
      longitud: -58.4548174,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 352,
      address: 'Rodríguez Peña 1185',
      latitud: -34.5952044,
      longitud: -58.3941356,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 354,
      address: 'Paraná 1053',
      latitud: -34.5964216,
      longitud: -58.3904649,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 355,
      address: 'Av. Pueyrredón 1054',
      latitud: -34.5978645,
      longitud: -58.4058641,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 356,
      address: 'Av. Callao 1289',
      latitud: -34.5975643,
      longitud: -58.3974014,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 357,
      address: 'Sarmiento 1592',
      latitud: -34.6054989,
      longitud: -58.3913684,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 360,
      address: 'Av. de Los Incas 5174',
      latitud: -34.5866827,
      longitud: -58.4834799,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 361,
      address: 'Moldes 1718',
      latitud: -34.5561478,
      longitud: -58.4778463,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '12 a 14',
    },
    {
      id: 362,
      address: 'Av. Directorio 1063',
      latitud: -34.6291607,
      longitud: -58.4446252,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 363,
      address: 'Av. Independencia 1833',
      latitud: -34.6180619,
      longitud: -58.3944733,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 364,
      address: 'Ciudad de la Paz 353',
      latitud: -34.5738736,
      longitud: -58.4442387,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 365,
      address: 'Nazca 1944',
      latitud: -34.6121406,
      longitud: -58.4831857,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 367,
      address: 'Estado de Israel 4309',
      latitud: -34.5977674,
      longitud: -58.4292098,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 368,
      address: 'Cuba 2919',
      latitud: -34.5533706,
      longitud: -58.4642977,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 369,
      address: 'Av. Caseros 2864',
      latitud: -34.6367816,
      longitud: -58.4053577,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 370,
      address: 'Av. Juan Bautista Alberdi 371',
      latitud: -34.622766,
      longitud: -58.4353016,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 371,
      address: 'Olazábal 5483',
      latitud: -34.5789501,
      longitud: -58.4927338,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 373,
      address: '11 de Septiembre 3910',
      latitud: -34.5432495,
      longitud: -58.4654045,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 18',
    },
    {
      id: 374,
      address: 'Dr. Rómulo Naón 2401',
      latitud: -34.5673266,
      longitud: -58.4749687,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '12 a 14',
    },
    {
      id: 375,
      address: 'Esmeralda 428',
      latitud: -34.6032106,
      longitud: -58.3803706,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 376,
      address: 'Álvarez Jonte 3709',
      latitud: -34.6133636,
      longitud: -58.4958634,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 378,
      address: 'Billinghurst 1876',
      latitud: -34.5889459,
      longitud: -58.411299,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 379,
      address: 'Maipú 26',
      latitud: -34.6047245,
      longitud: -58.3788658,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 380,
      address: 'Otamendi 454',
      latitud: -34.6111285,
      longitud: -58.4359443,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 391,
      address: 'Av. Cabildo 2865',
      latitud: -34.5557616,
      longitud: -58.4641852,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 392,
      address: 'Jorge Luis Borges 2463',
      latitud: -34.5822116,
      longitud: -58.4232157,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 394,
      address: 'Av. Santa Fe 4489',
      latitud: -34.5792106,
      longitud: -58.4261727,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 395,
      address: 'Av. Federico Lacroze 4106',
      latitud: -34.5859061,
      longitud: -58.4564122,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 396,
      address: 'Av. San Martín 2289',
      latitud: -34.585865,
      longitud: -58.4717331,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 397,
      address: 'Av. Corrientes 5980',
      latitud: -34.5935899,
      longitud: -58.4479264,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 398,
      address: 'Av. Rivadavia 9436',
      latitud: -34.6372193,
      longitud: -58.4991781,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 400,
      address: 'Av. del Barco Centenera 177',
      latitud: -34.6216606,
      longitud: -58.4432817,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 402,
      address: 'Av. Corrientes 1974',
      latitud: -34.603581,
      longitud: -58.4118332,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 403,
      address: 'Av. Santa Fe 5052',
      latitud: -34.6034874,
      longitud: -58.4380979,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 404,
      address: 'Av. Medrano 686',
      latitud: -34.6021372,
      longitud: -58.4231254,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 405,
      address: 'Av. Juan Bautista Alberdi 5719',
      latitud: -34.6506396,
      longitud: -58.5038907,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 406,
      address: 'Salta 1637',
      latitud: -34.6272426,
      longitud: -58.3851887,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 408,
      address: 'Perú 916',
      latitud: -34.6187275,
      longitud: -58.3764548,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 409,
      address: 'Av. Gaona 3567',
      latitud: -34.6208776,
      longitud: -58.4774057,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 410,
      address: 'Tucumán 2173',
      latitud: -34.6019202,
      longitud: -58.3981143,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 411,
      address: 'Eva Perón 3479',
      latitud: -34.6446326,
      longitud: -58.4669449,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 412,
      address: 'Av. Caseros 3535',
      latitud: -34.6386306,
      longitud: -58.4172657,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 413,
      address: 'Venezuela 4086',
      latitud: -34.6178978,
      longitud: -58.424585,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 414,
      address: 'Av. San Juan 3900',
      latitud: -34.6261216,
      longitud: -58.4223025,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 415,
      address: 'Av. San Juan 4351',
      latitud: -34.6267556,
      longitud: -58.4283247,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 416,
      address: 'Av. Almafuerte 880',
      latitud: -34.6481396,
      longitud: -58.4180607,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 417,
      address: 'Fray C. Rodríguez 464',
      latitud: -34.6244896,
      longitud: -58.4668107,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 418,
      address: 'Carlos Calvo 1826',
      latitud: -34.6202896,
      longitud: -58.3943927,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 419,
      address: 'Olavarría 469',
      latitud: -34.6364546,
      longitud: -58.3616187,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 420,
      address: 'Av. Gaona 1384',
      latitud: -34.6087986,
      longitud: -58.4508117,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 421,
      address: 'Av. Belgrano 3447',
      latitud: -34.6152766,
      longitud: -58.4172337,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 422,
      address: 'Murature 2169',
      latitud: -34.7062006,
      longitud: -58.4400641,
      city: 'Lomas de Zamora',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 423,
      address: 'Av. Castañares 4854',
      latitud: -34.6670646,
      longitud: -58.4751617,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 424,
      address: 'Bartolomé Mitre 226',
      latitud: -34.5656826,
      longitud: -59.1216007,
      city: 'Luján',
      state: 'Provincia de Buenos Aires',
      pagofacil: '8 a 11',
    },
    {
      id: 425,
      address: 'Av. Brig. Gral. Juan Manuel de Rosas 2553',
      latitud: -34.5310406,
      longitud: -58.5775977,
      city: 'Jose León Suárez',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 426,
      address: 'Montañeses 2067',
      latitud: -34.5576881,
      longitud: -58.4507565,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 427,
      address: 'Av. Rivadavia 16051',
      latitud: -34.6450126,
      longitud: -58.5927897,
      city: 'Haedo',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 428,
      address: 'Rosario 4558',
      latitud: -34.502456,
      longitud: -58.6704047,
      city: 'Adolfo Sordeaux',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 429,
      address: 'Independencia 4731',
      latitud: -34.5507114,
      longitud: -58.5565809,
      city: 'Villa Ballester',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 430,
      address: 'Carrillo 2170',
      latitud: -34.5758706,
      longitud: -58.5409267,
      city: 'San Martín',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 431,
      address: 'Av. Pdte. Tte. Gral. J. D. Perón 3283',
      latitud: -34.4535205,
      longitud: -58.540644,
      city: 'Victoria',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 433,
      address: 'Av. Ing. Eduardo Madero 1050',
      latitud: -34.4494426,
      longitud: -58.7992347,
      city: 'Del Viso',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 435,
      address: 'RP26 162',
      latitud: -34.4089426,
      longitud: -58.7736687,
      city: 'Maquinista Savio',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 436,
      address: 'Paraná 6543',
      latitud: -34.5257086,
      longitud: -58.5508517,
      city: 'Villa Adelina',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 437,
      address: 'Centenario 1890',
      latitud: -34.4613286,
      longitud: -58.5293617,
      city: 'Beccar',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 438,
      address: '25 de Mayo 2650',
      latitud: -34.5002976,
      longitud: -58.6970747,
      city: 'Los Polvorines',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 439,
      address: 'Gob. Arias 2420',
      latitud: -34.6510816,
      longitud: -58.6450727,
      city: 'Castelar',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 440,
      address: 'Av. Cazón 1336',
      latitud: -34.4249376,
      longitud: -58.5801687,
      city: 'Tigre',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 441,
      address: 'Vélez Sársfield 4690',
      latitud: -34.5306906,
      longitud: -58.5266267,
      city: 'Munro',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 442,
      address: 'Sarmiento 837',
      latitud: -34.6480146,
      longitud: -58.6224057,
      city: 'Morón',
      state: 'Provincia de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 443,
      address: 'Los Tilos 711',
      latitud: -34.6948472,
      longitud: -58.3005968,
      city: 'Don Bosco',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 444,
      address: 'Camino Gral. Belgrano 6498',
      latitud: -34.7804656,
      longitud: -58.2653187,
      city: 'Florencio Varela',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 445,
      address: 'Av. Arana 231',
      latitud: -34.8511556,
      longitud: -58.0792187,
      city: 'La Plata',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 446,
      address: 'Eva Perón 4461',
      latitud: -34.7291986,
      longitud: -58.3550807,
      city: 'Monte Chingolo',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 447,
      address: 'Cnel. D Elia 1649',
      latitud: -34.6908481,
      longitud: -58.410245,
      city: 'Lanús',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 448,
      address: 'Carlos Pellegrini 844',
      latitud: -34.8252458,
      longitud: -58.3904755,
      city: 'Burzaco',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 449,
      address: 'Sallares 151',
      latitud: -34.8080416,
      longitud: -58.2776177,
      city: 'Florencio Varela',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 450,
      address: 'Bolívar 1343',
      latitud: -34.7359522,
      longitud: -58.5187523,
      city: 'Longchamps',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 451,
      address: 'Guatambú 12',
      latitud: -34.8159016,
      longitud: -58.4297497,
      city: 'Almirante Brown',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 452,
      address: 'Av. Centenario 5331',
      latitud: -34.5886948,
      longitud: -58.5482194,
      city: 'Ezpeleta',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 453,
      address: 'Martín Rodríguez 1399',
      latitud: -34.7352126,
      longitud: -58.4360477,
      city: 'Banfield',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 454,
      address: 'Av. Mitre 573',
      latitud: -34.7202566,
      longitud: -58.2571397,
      city: 'Quilmes',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 455,
      address: 'Av. Hipólito Yrigoyen 2323',
      latitud: -34.720091,
      longitud: -58.3249909,
      city: 'Gerli',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 456,
      address: 'Av. Gral. José de San Martín 3960',
      latitud: -34.7107886,
      longitud: -58.4247577,
      city: 'Remedios de Escalada',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 A 17',
    },
    {
      id: 457,
      address: 'Sarmiento 72',
      latitud: -34.8891246,
      longitud: -58.3874587,
      city: 'Glew',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 458,
      address: 'Claudio de Alas 2146',
      latitud: -34.720396,
      longitud: -58.4627447,
      city: 'Budge',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 459,
      address: 'Camino Gral. Belgrano 4861',
      latitud: -34.7223646,
      longitud: -58.3411937,
      city: 'Lanús',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 460,
      address: 'Eva Perón 3330',
      latitud: -34.7209476,
      longitud: -58.3652697,
      city: 'Lanús',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 461,
      address: 'Salta 160',
      latitud: -34.7628844,
      longitud: -58.3603804,
      city: 'Lomas de Zamora',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 462,
      address: '12 de Octubre 520',
      latitud: -34.7297509,
      longitud: -58.2660792,
      city: 'Quilmes',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 463,
      address: 'Pres. Tte. Gral. J. D. Perón 2640',
      latitud: -34.6735116,
      longitud: -58.4084777,
      city: 'Valentín Alsina',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 464,
      address: 'Av. Eva Perón 5492',
      latitud: -34.7525085,
      longitud: -58.3454181,
      city: 'Lomas de Zamora',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 465,
      address: 'Av. Mitre 6328',
      latitud: -34.7041776,
      longitud: -58.3191217,
      city: 'Wilde',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 466,
      address: '29 de Septiembre 1880',
      latitud: -34.7064766,
      longitud: -58.3920427,
      city: 'Lanús',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 467,
      address: 'Bvard. A. Alcorta 2854',
      latitud: -34.6503586,
      longitud: -58.7933607,
      city: 'Moreno',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 468,
      address: 'Juan Manuel de Rosas 6956',
      latitud: -34.7043927,
      longitud: -58.5830034,
      city: 'Isidro Casanova',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 469,
      address: 'Fraga 1629',
      latitud: -34.5441846,
      longitud: -58.7170887,
      city: 'San Miguel',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 470,
      address: 'El Payador 5550',
      latitud: -34.5888208,
      longitud: -58.575342,
      city: 'Villa Bosh',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 471,
      address: 'Av. Honorio Luque 6101',
      latitud: -34.7505396,
      longitud: -58.5882297,
      city: 'Gregorio de Laferrere',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 472,
      address: 'Jauretche 1125',
      latitud: -34.5896126,
      longitud: -58.6349887,
      city: 'Hurlingham',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 473,
      address: '9 de Julio 46',
      latitud: -34.6487556,
      longitud: -58.6206177,
      city: 'Ramos Mejía',
      state: 'Provincia de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 474,
      address: 'Echeverri 943',
      latitud: -34.7035536,
      longitud: -58.7455797,
      city: 'Merlo',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 475,
      address: 'Av. de Mayo 1832',
      latitud: -34.6432866,
      longitud: -58.5620564,
      city: 'Ramos Mejía',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 476,
      address: 'Chilavert 1912',
      latitud: -34.6911036,
      longitud: -58.4839497,
      city: 'Villa Celina',
      state: 'Provincia de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 477,
      address: 'Dr. Enrique Simón Pérez 4566',
      latitud: -34.7730936,
      longitud: -58.6474067,
      city: 'La Matanza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 478,
      address: 'Misiones 6572',
      latitud: -34.6053926,
      longitud: -58.5971887,
      city: 'Palomar',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 479,
      address: 'Avenida Eva Perón 4215',
      latitud: -34.6900854,
      longitud: -58.6890657,
      city: 'Merlo',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 480,
      address: 'Av. Crovara 875',
      latitud: -34.6792056,
      longitud: -58.5123997,
      city: 'La Matanza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 481,
      address: 'Boulogne Sur Mer 1398',
      latitud: -34.6974686,
      longitud: -58.5094537,
      city: 'Tapiales',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 482,
      address: 'Alejandro Sullivan 1597',
      latitud: -34.6536206,
      longitud: -58.7169216,
      city: 'San Antonio de Padua',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 483,
      address: 'Av. Carlos Casares 642',
      latitud: -34.6977471,
      longitud: -58.6275444,
      city: 'La Matanza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 484,
      address: 'Salvador María del Carril 49',
      latitud: -34.6573156,
      longitud: -58.7651347,
      city: 'Paso del Rey',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 485,
      address: 'Av. Pdte. J. D. Perón 23866',
      latitud: -34.6659585,
      longitud: -58.7012686,
      city: 'San Antonio de Padua',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 486,
      address: 'Av. San Juan 1374',
      latitud: -34.6224636,
      longitud: -58.3878047,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 487,
      address: 'La Rioja 2040',
      latitud: -34.6351365,
      longitud: -58.4076433,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 488,
      address: 'Av. Belgrano 1562',
      latitud: -34.6136756,
      longitud: -58.3904427,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 489,
      address: 'Av. Caseros 2423',
      latitud: -34.6353206,
      longitud: -58.3984897,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 492,
      address: 'Pedro Lozano 3150',
      latitud: -34.601152,
      longitud: -58.4969934,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 493,
      address: 'Charcas 3940',
      latitud: -34.5866216,
      longitud: -58.4215637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 494,
      address: 'Fco. Seguí 1519',
      latitud: -34.4852266,
      longitud: -58.7287143,
      city: 'Grand Bourg',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 495,
      address: 'Avenida 14 5072',
      latitud: -34.7601896,
      longitud: -58.208862,
      city: 'Berazategui',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 496,
      address: 'José Hernández 130',
      latitud: -34.8541694,
      longitud: -58.5238344,
      city: 'Ezeiza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 497,
      address: 'Av. Juan Domingo Perón 25694',
      latitud: -34.6653329,
      longitud: -58.7304928,
      city: 'Merlo',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 498,
      address: 'Luro 6329',
      latitud: -34.7516496,
      longitud: -58.5856277,
      city: 'Gregorio de Laferrere',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 499,
      address: 'Av. Cristianía 1832',
      latitud: -34.6975266,
      longitud: -58.6034477,
      city: 'La Matanza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 521,
      address: 'Av. Urquiza 4855',
      latitud: -34.6056286,
      longitud: -58.5670707,
      city: '3 de Febrero',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 522,
      address: 'Arieta 2850',
      latitud: -34.6762126,
      longitud: -58.5657357,
      city: 'La Matanza',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 524,
      address: 'Bernardo de Irigoyen 746',
      latitud: -34.6081856,
      longitud: -58.9557587,
      city: 'General Rodríguez',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 525,
      address: 'Crisólogo Larralde 3721',
      latitud: -34.5553406,
      longitud: -58.4822337,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 526,
      address: 'H. Pueyrredón 925',
      latitud: -34.6095616,
      longitud: -58.4459347,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 527,
      address: 'Fray Justo Sta. María de Oro 2121',
      latitud: -34.5835221,
      longitud: -58.4300285,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 528,
      address: 'Aguirre 236',
      latitud: -34.5998066,
      longitud: -58.4359897,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 529,
      address: 'Viamonte 2296',
      latitud: -34.6011734,
      longitud: -58.4017945,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 530,
      address: 'Av. Rivadavia 6074',
      latitud: -34.6246826,
      longitud: -58.4534367,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 531,
      address: 'Arévalo 1736',
      latitud: -34.5805486,
      longitud: -58.4423987,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 532,
      address: 'Av. Cabildo 3722',
      latitud: -34.5488446,
      longitud: -58.4707497,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 533,
      address: 'Rosario 85',
      latitud: -34.6183226,
      longitud: -58.4318827,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 534,
      address: 'Martiniano Leguizamón 1576',
      latitud: -34.6532276,
      longitud: -58.5094457,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 535,
      address: 'Murguiondo 4324',
      latitud: -34.6777567,
      longitud: -58.4741762,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 536,
      address: 'Ricardo Balbín 4189',
      latitud: -34.5549913,
      longitud: -58.493104,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 537,
      address: 'Charcas 4389',
      latitud: -34.5848489,
      longitud: -58.4235207,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 538,
      address: 'Hipólito Yrigoyen 3254',
      latitud: -34.6124223,
      longitud: -58.41482,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 539,
      address: 'Donato Álvarez 837',
      latitud: -34.6163923,
      longitud: -58.4582589,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 540,
      address: 'Av. Leandro N. Alem 432',
      latitud: -34.6025406,
      longitud: -58.3727377,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '15 a 17',
    },
    {
      id: 541,
      address: 'Maipú 918',
      latitud: -34.5972756,
      longitud: -58.3791637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 542,
      address: 'Segurola 279',
      latitud: -34.6314044,
      longitud: -58.4875611,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 543,
      address: 'Olazábal 5179',
      latitud: -34.5767144,
      longitud: -58.4889788,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 544,
      address: 'Juana Manso 550',
      latitud: -34.6053425,
      longitud: -58.367594,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 545,
      address: 'Libertad 1043',
      latitud: -34.5962793,
      longitud: -58.3863211,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 546,
      address: 'Moreno 1902',
      latitud: -34.6128746,
      longitud: -58.3954817,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 547,
      address: 'Av. Dorrego 851',
      latitud: -34.5914156,
      longitud: -58.4491097,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 548,
      address: 'Av. Congreso 5241',
      latitud: -34.5706136,
      longitud: -58.4940857,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 549,
      address: 'Suipacha 366',
      latitud: -34.6041936,
      longitud: -58.3816977,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 550,
      address: 'Sarmiento 3885',
      latitud: -34.6050646,
      longitud: -58.4214307,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 551,
      address: 'Monroe 3576',
      latitud: -34.565322,
      longitud: -58.4730644,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 552,
      address: 'Av. Rivadavia 3751',
      latitud: -34.6109496,
      longitud: -58.4212907,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 553,
      address: 'Cuzco 135',
      latitud: -34.6380186,
      longitud: -58.5297947,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 554,
      address: 'Chilavert 6280',
      latitud: -34.6881091,
      longitud: -58.4803572,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 555,
      address: 'Güemes 4159',
      latitud: -34.5846906,
      longitud: -58.421115,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 556,
      address: 'Grecia 3595',
      latitud: -34.5464926,
      longitud: -58.4653282,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 557,
      address: 'Arzobispo Espinosa 1187',
      latitud: -34.6339431,
      longitud: -58.3685468,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 558,
      address: 'Sarmiento 345',
      latitud: -34.6041691,
      longitud: -58.3738017,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '9 a 14',
    },
    {
      id: 559,
      address: 'Teodoro García 2310',
      latitud: -34.568377,
      longitud: -58.4465795,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 560,
      address: 'Bartolomé Mitre 1751',
      latitud: -34.6078832,
      longitud: -58.3935499,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 561,
      address: 'Av. Ángel Gallardo 940',
      latitud: -34.6046943,
      longitud: -58.4403802,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 562,
      address: 'San Martín 620',
      latitud: -34.6008096,
      longitud: -58.3762957,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 A 20',
    },
    {
      id: 563,
      address: 'Hidalgo 955',
      latitud: -34.6082996,
      longitud: -58.4435577,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 565,
      address: 'Ecuador 932',
      latitud: -34.5990604,
      longitud: -58.4083676,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 566,
      address: 'Av. Álvarez Thomas 1996',
      latitud: -34.5787386,
      longitud: -58.4714627,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 568,
      address: 'Olazábal 1898',
      latitud: -34.5574376,
      longitud: -58.4556927,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 A 10',
    },
    {
      id: 569,
      address: 'Del Libertador 1140',
      latitud: -34.5857249,
      longitud: -58.3878645,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 570,
      address: 'Defensa 1400',
      latitud: -34.6240594,
      longitud: -58.3732525,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 571,
      address: 'Tacuarí 89',
      latitud: -34.6093006,
      longitud: -58.3814317,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 572,
      address: 'Centenera 1282',
      latitud: -34.6343286,
      longitud: -58.4379857,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 573,
      address: 'Av. Córdoba 3721',
      latitud: -34.5976067,
      longitud: -58.4214011,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 574,
      address: 'García del Río 3166',
      latitud: -34.5502083,
      longitud: -58.4787574,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 575,
      address: 'Directorio 483',
      latitud: -34.6277322,
      longitud: -58.435643,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 576,
      address: 'Núñez 1563',
      latitud: -34.5456329,
      longitud: -58.4618197,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 577,
      address: 'Av. Córdoba 2038',
      latitud: -34.5998767,
      longitud: -58.3984611,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 578,
      address: 'Av. Callao 678',
      latitud: -34.5995669,
      longitud: -58.4142759,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 579,
      address: 'Av. Almirante Brown 795',
      latitud: -34.6319926,
      longitud: -58.3634667,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 580,
      address: 'Av. Corrientes 4147',
      latitud: -34.602581,
      longitud: -58.4252761,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 581,
      address: 'Juan María Gutiérrez 3759',
      latitud: -34.5808301,
      longitud: -58.4152862,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 582,
      address: 'Av. Congreso 4781',
      latitud: -34.5675836,
      longitud: -58.4886247,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 583,
      address: 'Av. de Mayo 1241',
      latitud: -34.6091488,
      longitud: -58.3862359,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 584,
      address: 'Urquiza 648',
      latitud: -34.6179996,
      longitud: -58.4113957,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 585,
      address: 'Lima 945',
      latitud: -34.619084,
      longitud: -58.3837845,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 586,
      address: 'Av. San Martín 5930',
      latitud: -34.5959014,
      longitud: -58.5022266,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 587,
      address: 'Rojas 16',
      latitud: -34.6201997,
      longitud: -58.4438985,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 588,
      address: 'Av. San Martín 4685',
      latitud: -34.5974926,
      longitud: -58.4867637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 589,
      address: 'Perú 487',
      latitud: -34.6136206,
      longitud: -58.3768907,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 590,
      address: 'Peña 2544',
      latitud: -34.5889366,
      longitud: -58.4024927,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 591,
      address: 'Tte. Gral. J. D. Perón 4177',
      latitud: -34.6058503,
      longitud: -58.4278086,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '10 a 12',
    },
    {
      id: 592,
      address: 'Echeverría 1420',
      latitud: -34.5571456,
      longitud: -58.4480577,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 593,
      address: 'Entre Ríos 1192',
      latitud: -34.6225986,
      longitud: -58.3935297,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 594,
      address: 'Inclan 2502',
      latitud: -34.6298816,
      longitud: -58.4018987,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 595,
      address: 'Cosquín 78',
      latitud: -34.6398946,
      longitud: -58.5257737,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 596,
      address: 'Av. Federico Lacroze 3660',
      latitud: -34.5790448,
      longitud: -58.4588997,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 597,
      address: 'Sanabria 2733',
      latitud: -34.6110646,
      longitud: -58.5085147,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 598,
      address: 'Sarmiento 1810',
      latitud: -34.6057903,
      longitud: -58.3946169,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 599,
      address: 'Blanco Encalada 4470',
      latitud: -34.57176,
      longitud: -58.4820476,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 600,
      address: 'Directorio 3960',
      latitud: -34.6411401,
      longitud: -58.4814026,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 602,
      address: 'Av. Rivadavia 8688',
      latitud: -34.6350547,
      longitud: -58.4884833,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 604,
      address: 'Av. Estado de Israel 4684',
      latitud: -34.6007288,
      longitud: -58.433035,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 605,
      address: 'Av. Juan Bautista Alberdi 7071',
      latitud: -34.659228,
      longitud: -58.5151507,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 606,
      address: 'Ovispo Trejo 1166',
      latitud: -31.428959,
      longitud: -64.1933487,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 607,
      address: 'Chacabuco 727',
      latitud: -31.426127,
      longitud: -64.1857697,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 608,
      address: 'Serrano 280',
      latitud: -34.598185,
      longitud: -58.4471717,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 609,
      address: 'Av. del Libertador 4534',
      latitud: -34.5665327,
      longitud: -58.4341149,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 610,
      address: 'Av. Pueyrredón 298',
      latitud: -31.42599,
      longitud: -64.1950161,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 613,
      address: 'Av. Congreso 2774',
      latitud: -34.5573706,
      longitud: -58.4680318,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '12 a 14',
    },
    {
      id: 614,
      address: 'Murguiondo 4054',
      latitud: -34.6756839,
      longitud: -58.4793661,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 615,
      address: 'Av. Rivadavia 4702',
      latitud: -34.6163732,
      longitud: -58.4339626,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 616,
      address: 'Río de Janeiro 71',
      latitud: -34.614357,
      longitud: -58.4321587,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 617,
      address: 'Monroe 3131',
      latitud: -34.5624476,
      longitud: -58.4692605,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 618,
      address: 'Bulnes 2751',
      latitud: -34.58051,
      longitud: -58.4080587,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 619,
      address: 'Ramos Mejía 1019',
      latitud: -34.58049,
      longitud: -58.4759102,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 620,
      address: 'Marcelo T. de Alvear 1626',
      latitud: -34.5973125,
      longitud: -58.3923351,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 621,
      address: 'Av. Avellaneda 1034',
      latitud: -34.6173994,
      longitud: -58.4475717,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 622,
      address: 'Boyacá 1082',
      latitud: -34.616074,
      longitud: -58.4664747,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 623,
      address: 'Av. Rivadavia 2520',
      latitud: -34.6100856,
      longitud: -58.4042329,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 624,
      address: 'Nazca 3214',
      latitud: -34.5989937,
      longitud: -58.4939974,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 625,
      address: 'Montiel 1061',
      latitud: -34.6508587,
      longitud: -58.5280729,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 626,
      address: 'Ramón Falcón 5547',
      latitud: -34.6390201,
      longitud: -58.5071339,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 627,
      address: 'Av. Paseo Colón 1179',
      latitud: -34.621333,
      longitud: -58.3706667,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 628,
      address: 'Av. Rivadavia 4119',
      latitud: -34.6112829,
      longitud: -58.417389,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 630,
      address: 'Aráoz 2148',
      latitud: -34.5881846,
      longitud: -58.4213637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 631,
      address: 'Lavalle 368',
      latitud: -34.6019826,
      longitud: -58.3741377,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 632,
      address: 'Amenábar 2710',
      latitud: -34.5578416,
      longitud: -58.4654071,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 633,
      address: 'Bolívar 270',
      latitud: -34.6112146,
      longitud: -58.3755287,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 634,
      address: 'Moreno 1401',
      latitud: -34.6121916,
      longitud: -58.3884097,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 635,
      address: 'Viamonte 1380',
      latitud: -34.6000828,
      longitud: -58.3835572,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 636,
      address: 'Ayacucho 1401',
      latitud: -34.5926966,
      longitud: -58.3970197,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 637,
      address: 'San Martín 2218',
      latitud: -34.6026742,
      longitud: -58.5616682,
      city: 'Caseros',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 638,
      address: 'Av. de Mayo 432',
      latitud: -34.5746868,
      longitud: -58.7468581,
      city: 'Derqui',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 639,
      address: 'Pedro Goyena 188',
      latitud: -34.6254656,
      longitud: -58.4321182,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 640,
      address: 'Boulogne Sur Mer 431',
      latitud: -34.6050977,
      longitud: -58.4089587,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 641,
      address: 'Alvear 126',
      latitud: -31.4153774,
      longitud: -64.1827027,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 642,
      address: 'Gral. Paz 240',
      latitud: -31.4124804,
      longitud: -64.1874667,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 643,
      address: 'Segurola 1441',
      latitud: -34.6225038,
      longitud: -58.4985783,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 644,
      address: '25 de Mayo 979',
      latitud: -34.5002976,
      longitud: -58.6970747,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 645,
      address: 'Luis María Drago 285',
      latitud: -34.6014599,
      longitud: -58.4391713,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 646,
      address: 'Bauness 2692',
      latitud: -34.5728366,
      longitud: -58.4916997,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 648,
      address: 'Belgrano 54',
      latitud: -31.4154168,
      longitud: -64.1906725,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 649,
      address: 'Av. Emilio Castro 6817',
      latitud: -34.6519732,
      longitud: -58.5180431,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 650,
      address: 'San Martín 26',
      latitud: -31.4205366,
      longitud: -64.4989004,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 652,
      address: 'Av. Gral. Las Heras 2986',
      latitud: -34.5835971,
      longitud: -58.4059972,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 654,
      address: 'Hipólito Yrigoyen 1790',
      latitud: -34.6104553,
      longitud: -58.3936237,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 655,
      address: 'Sarmiento 774',
      latitud: -34.604809,
      longitud: -58.3797209,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '15 a 17',
    },
    {
      id: 656,
      address: 'Viamonte 170',
      latitud: -34.5995547,
      longitud: -58.372246,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 657,
      address: 'Montiel 1718',
      latitud: -34.6570375,
      longitud: -58.5202075,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 658,
      address: 'Av. Larrazábal 265',
      latitud: -34.642101,
      longitud: -58.5162423,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 659,
      address: 'Conesa 999',
      latitud: -34.5728926,
      longitud: -58.4534585,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 660,
      address: 'Juan Seguí 4524',
      latitud: -34.5740506,
      longitud: -58.4226637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 661,
      address: 'Aráoz 1140',
      latitud: -34.5944073,
      longitud: -58.4310502,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 662,
      address: 'Av. Belgrano 3043',
      latitud: -34.6150025,
      longitud: -58.411227,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 663,
      address: 'Alsina 725',
      latitud: -34.6104128,
      longitud: -58.3788307,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 664,
      address: 'Nogoyá 3644',
      latitud: -34.6064416,
      longitud: -58.4999217,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 665,
      address: 'Av. Gaona 2964',
      latitud: -34.6171776,
      longitud: -58.4696427,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 667,
      address: 'Av. Directorio 4989',
      latitud: -34.6507146,
      longitud: -58.4929417,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 668,
      address: 'Juana Manso 199',
      latitud: -34.5998941,
      longitud: -58.3661912,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 14',
    },
    {
      id: 669,
      address: 'Yapeyú 2059',
      latitud: -34.5754986,
      longitud: -58.5380417,
      city: 'San Martín',
      state: 'Provincia de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 670,
      address: 'Hidalgo 92',
      latitud: -34.6177786,
      longitud: -58.4405647,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 671,
      address: 'Sucre 2774',
      latitud: -34.5659736,
      longitud: -58.4605987,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 672,
      address: 'Coronel Martiniano Chilavert 6901',
      latitud: -34.6894762,
      longitud: -58.479574,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 673,
      address: 'Carrasco 421',
      latitud: -34.6322086,
      longitud: -58.4933727,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 674,
      address: 'Virrey del Pino 2527',
      latitud: -34.5670295,
      longitud: -58.4563744,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '08 a 10',
    },
    {
      id: 675,
      address: 'Av. Cabildo 4861',
      latitud: -34.5401493,
      longitud: -58.4767958,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 676,
      address: 'Chile 701',
      latitud: -34.6161726,
      longitud: -58.3782797,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 677,
      address: 'Álvarez Jonte 3079',
      latitud: -34.6094018,
      longitud: -58.4882248,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 678,
      address: 'Arregui 6369',
      latitud: -34.6283339,
      longitud: -58.5262897,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 679,
      address: 'Av. Raúl Scalabrini Ortiz 1396',
      latitud: -34.5921666,
      longitud: -58.4294107,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 680,
      address: 'Carhué 1427',
      latitud: -34.6540918,
      longitud: -58.521156,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 682,
      address: 'Viamonte 702',
      latitud: -34.5998572,
      longitud: -58.3754338,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 683,
      address: 'Av. Crámer 2463',
      latitud: -34.5612839,
      longitud: -58.4663222,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 684,
      address: 'México 1530',
      latitud: -34.6156695,
      longitud: -58.3901139,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 685,
      address: 'Pareja 4890',
      latitud: -34.6055699,
      longitud: -58.526124,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 686,
      address: 'Juan Agustín García 3202',
      latitud: -34.6125656,
      longitud: -58.4882617,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 687,
      address: 'Álvarez Jonte 1938',
      latitud: -34.6035045,
      longitud: -58.4732137,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 688,
      address: 'Av. Lope de Vega 19',
      latitud: -34.6369056,
      longitud: -58.5016547,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 689,
      address: 'Av. Independencia 2716',
      latitud: -34.6190006,
      longitud: -58.4060857,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 691,
      address: 'Av. La Plata 716',
      latitud: -34.6217727,
      longitud: -58.4298927,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 692,
      address: 'Neuquén 520',
      latitud: -34.6160648,
      longitud: -58.4401833,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 693,
      address: 'Pedro Goyena 1680',
      latitud: -34.6285355,
      longitud: -58.4542743,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 694,
      address: 'Tucumán 1541',
      latitud: -34.6018911,
      longitud: -58.3955887,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 695,
      address: 'Almirante Brown 261',
      latitud: -34.628609,
      longitud: -58.3662296,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 697,
      address: 'Caboto 420',
      latitud: -34.6277856,
      longitud: -58.3624837,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 698,
      address: 'Beláustegui 2748',
      latitud: -34.6154476,
      longitud: -58.4775147,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 699,
      address: 'Av. Dorrego 2145',
      latitud: -34.5780957,
      longitud: -58.4415052,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 710,
      address: 'Nahuel Huapi 5038',
      latitud: -34.5711246,
      longitud: -58.4905687,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 711,
      address: 'Av. Álvarez Thomas 372',
      latitud: -34.5812184,
      longitud: -58.4490234,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 713,
      address: 'Bermúdez 2446',
      latitud: -34.616418,
      longitud: -58.5157896,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 714,
      address: 'Mariscal Sucre 4230',
      latitud: -34.5743009,
      longitud: -58.4728412,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 715,
      address: 'Av. Córdoba 4967',
      latitud: -34.5916106,
      longitud: -58.4360887,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 716,
      address: 'Castañeda 1836',
      latitud: -34.5541269,
      longitud: -58.4388262,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 717,
      address: 'Junín 1460',
      latitud: -34.5912826,
      longitud: -58.3976967,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 719,
      address: 'Yerbal 2701',
      latitud: -34.6286806,
      longitud: -58.4697897,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 720,
      address: 'Independencia 585',
      latitud: -31.4229773,
      longitud: -64.1869765,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '14 a 17',
    },
    {
      id: 721,
      address: 'Tres de Febrero 1857',
      latitud: -34.5616046,
      longitud: -58.4521557,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 723,
      address: 'Av. Leandro N. Alem 198',
      latitud: -34.6054461,
      longitud: -58.3726001,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 724,
      address: 'Ayacucho 539',
      latitud: -34.6027436,
      longitud: -58.3975517,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 725,
      address: 'Av. Directorio 2320',
      latitud: -34.6332239,
      longitud: -58.4614736,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 726,
      address: 'Av. Lisandro de Latorre 199',
      latitud: -34.6412216,
      longitud: -58.5232877,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 727,
      address: 'Montiel 168',
      latitud: -34.6410686,
      longitud: -58.5284247,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 728,
      address: 'Artigas 5190',
      latitud: -34.5795776,
      longitud: -58.5035287,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 729,
      address: 'Av. Belgrano 2160',
      latitud: -34.613801,
      longitud: -58.3942035,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 730,
      address: 'Esmeralda 151',
      latitud: -34.6064406,
      longitud: -58.3800497,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 731,
      address: 'Sarmiento 4551',
      latitud: -34.6039986,
      longitud: -58.4318237,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 732,
      address: 'Ambrosetti 758',
      latitud: -34.6096916,
      longitud: -58.4409117,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 733,
      address: 'Av. Lisandro de Latorre 790',
      latitud: -34.6474686,
      longitud: -58.5220357,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 734,
      address: 'Urquiza 1015',
      latitud: -34.6226956,
      longitud: -58.4113847,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 735,
      address: 'Av. Pueyrredón 2120',
      latitud: -34.58767,
      longitud: -58.4001927,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '8 a 10',
    },
    {
      id: 736,
      address: 'Chile 154',
      latitud: -31.4303741,
      longitud: -64.1879054,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 739,
      address: 'Franklin D Roosevelt 3002',
      latitud: -34.5609041,
      longitud: -58.4683804,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '12 a 14',
    },
    {
      id: 740,
      address: 'Av. Varela 888',
      latitud: -34.6393497,
      longitud: -58.46075,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 741,
      address: 'Av. Triunvirato 4210',
      latitud: -34.5782906,
      longitud: -58.4828047,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 742,
      address: 'Av. Juan Bautista Alberdi 5494',
      latitud: -34.6490206,
      longitud: -58.5017197,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 743,
      address: 'Avenida Callao 1043',
      latitud: -34.5967065,
      longitud: -58.3952886,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 744,
      address: 'Av. Independencia 907',
      latitud: -34.6174216,
      longitud: -58.3810917,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 745,
      address: 'Serrano 1458',
      latitud: -34.5896236,
      longitud: -58.4338637,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 747,
      address: 'Cabrera 4106',
      latitud: -34.5961553,
      longitud: -58.4265474,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 748,
      address: 'Malabia 494',
      latitud: -34.5982414,
      longitud: -58.4409602,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 751,
      address: 'Esmeralda 1040',
      latitud: -34.5959616,
      longitud: -58.3807147,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '12 a 14',
    },
    {
      id: 752,
      address: 'Balcarce 379',
      latitud: -34.6121292,
      longitud: -58.3705379,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 9',
    },
    {
      id: 753,
      address: 'Lavalle 650',
      latitud: -34.6022296,
      longitud: -58.3781277,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '14 a 16',
    },
    {
      id: 754,
      address: 'Avenida General Las Heras 3315',
      latitud: -34.5829101,
      longitud: -58.4095515,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 755,
      address: 'Concejal Tribulato 1279',
      latitud: -34.5417946,
      longitud: -58.7163047,
      city: 'San Miguel',
      state: 'Provincia de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 757,
      address: 'Avenida Santa Fe 2429',
      latitud: -34.5917125,
      longitud: -58.4085103,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '7 a 10',
    },
    {
      id: 760,
      address: 'Avenida Santa Fe 1377',
      latitud: -34.5955578,
      longitud: -58.3888269,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 761,
      address: 'Av. Corrientes 921',
      latitud: -34.6034727,
      longitud: -58.3820621,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 762,
      address: 'Sarachaga 780',
      latitud: -31.3909351,
      longitud: -64.187055,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '7 a 12',
    },
    {
      id: 763,
      address: 'Av. San Juan 3334',
      latitud: -34.625187,
      longitud: -58.4150676,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
    {
      id: 764,
      address: 'San Lorenzo 484',
      latitud: -31.4252656,
      longitud: -64.1829068,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 765,
      address: 'Buenos Aires 65',
      latitud: -31.4171439,
      longitud: -64.1851397,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 766,
      address: '27 de abril 458',
      latitud: -31.4152268,
      longitud: -64.192786,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '14 a 17',
    },
    {
      id: 767,
      address: '24 de Septiembre 1594',
      latitud: -31.412878,
      longitud: -64.1630652,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 768,
      address: 'Independencia 855',
      latitud: -31.4262728,
      longitud: -64.1904834,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 769,
      address: 'San Martín 625',
      latitud: -31.4177162,
      longitud: -64.4941153,
      city: 'Villa Carlos Paz',
      state: 'Córdoba',
      pagofacil: '14 a 17',
    },
    {
      id: 770,
      address: 'Ituzaingo 514',
      latitud: -31.4231024,
      longitud: -64.1840118,
      city: 'Nueva Córdoba',
      state: 'Córdoba',
      pagofacil: '14 a 17',
    },
    {
      id: 771,
      address: 'Santa Fe 723',
      latitud: -31.40308,
      longitud: -64.2010463,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '14 a 17',
    },
    {
      id: 772,
      address: 'Juan A. Lavalleja 49',
      latitud: -31.4129699,
      longitud: -64.1942514,
      city: 'Córdoba',
      state: 'Córdoba',
      pagofacil: '',
    },
    {
      id: 774,
      address: 'Av. Saenz Peña 1050',
      latitud: -34.6527623,
      longitud: -58.4182519,
      city: 'Ciudad Autónoma de Buenos Aires',
      state: 'Ciudad Autónoma de Buenos Aires',
      pagofacil: '',
    },
  ],
}).render(document.getElementById('wrapper'));
